import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import WhatIsYourGoalStep from '../../steps/WhatIsYourGoalStep';
import { OnboardingNode } from '../../types';

export const RECOVERY_GOAL_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.RECOVERY_GOAL,
  options: { countsTowardProgressBar: false, optional: true },
  elements: [
    {
      uid: OnboardingStepType.RECOVERY_GOAL,
      component: (
        <WhatIsYourGoalStep
          uid={OnboardingStepType.RECOVERY_GOAL}
          nodeType={OnboardingNodeType.RECOVERY_GOAL}
          displayName="Your Treatment Needs & Goals"
          actionButtonText="Next"
        />
      )
    }
  ]
};
